import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';
@Pipe({ name: 'chatDate' })
export class chatDatePipe implements PipeTransform {
    transform(date: string,showTime?:boolean) {
        if (!date) {
            return "";
        }
        return this.convert(date,showTime);
    }
    formatDateTime(inputTime) {
        // inputTime = 1528788278000;
        var date = new Date(inputTime);
        if (date == null || date == undefined) {
            return;
        }
        var y = date.getFullYear();
        var _m = date.getMonth() + 1;
        var m = _m < 10 ? ('0' + _m) : _m;
        var _d = date.getDate();
        var d = _d < 10 ? ('0' + _d) : _d;
        var _h = date.getHours();
        var h = _h < 10 ? ('0' + _h) : _h;
        var _minute = date.getMinutes();
        var _second = date.getSeconds();
        var minute = _minute < 10 ? ('0' + _minute) : _minute;
        var second = _second < 10 ? ('0' + _second) : _second;
        var hours = date.getHours();
        var timeValue = "" + ((hours >= 12) ? "下午 " : "上午 ")
        // /
        // console.log("--y:"+y+"--m:"+m+"--d--:"+d+"--h:"+h+"--minute--:"+minute)
        var now = new Date();
        var nowy = now.getFullYear();
        var _nowm = now.getMonth() + 1;
        var _nowd = now.getDate();
        var nowd_z = _nowd - 1;
        var nowm = _nowm < 10 ? ('0' + _nowm) : _nowm;
        var nowd = _nowd < 10 ? ('0' + _nowd) : _nowd;
        // console.log("--nowy:"+nowy+"--nowmm:"+nowm+"--d--:"+nowd )
        var returnStr = "";
        if (nowm == m && nowy == y && nowd == d) {
            returnStr = timeValue + h + ':' + minute;
        }
        if (nowm == m && nowy == y && nowd_z == d) {
            returnStr = " 昨天  " + h + ':' + minute;
        }
        if (nowy == y && nowd_z != d && nowd != d) {
            returnStr = m + '-' + d;
        }
        if (nowy != y) {
            returnStr = y + '-' + m + '-' + d;
        }

        return returnStr;
    }


    convert(value,showTime) {
        var time = new Date(value);
        let str;
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const yesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
        const beforeYesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 2);
        const monday = new Date(today);
        monday.setDate(today.getDate() - (today.getDay() ? today.getDay() - 1 : 6));
        //注意：date初始化默认是按本地时间初始的，但打印默认却是按GMT时间打印的，也就是说打印出的不是本地现在的时间
        //LocaleString的打印也有点问题，"0点"会被打印为"上午12点"
        if (time.getTime() > today.getTime()) {
            str = "";
        } else if (time.getTime() > yesterday.getTime()) {
            str = "昨天";
        } else if (time.getTime() > beforeYesterday.getTime()) {
            str = "前天";
        } else if (time.getTime() > monday.getTime()) {
            const week = { "0": "周日", "1": "周一", "2": "周二", "3": "周三", "4": "周四", "5": "周五", "6": "周六" };
            str = week[time.getDay() + ""];
        } else {
            const hour = ["凌晨", "早上", "下午", "晚上"];
            const h = time.getHours();
            if (h == 12) {
                str = "中午";
            }
            else {
                var t = (h / 6).toString(); str = hour[parseInt(t)];
            }
            str = this.format(time,"yy/MM/dd");
        }
       if(str==''){
        str += this.format(time,"HH:mm");
       }
        return str;
    }

    format(time,fmt) {
        const o = {
            "y+": time.getFullYear(),
            "M+": time.getMonth()+1,
            "d+": time.getDate(),
            "H+": time.getHours(),
            "m+": time.getMinutes(),
            "s+": time.getSeconds(),
            "S+": time.getMilliseconds(),
            "q+": Math.floor(time.getMonth()/3) + 1,
            "h+": (()=>{
                const hour=time.getHours()%12;
                return hour==0?12:hour;
            })(),
            "E+": (()=>{
                const week = {"0":"Sunday","1":"Monday","2":"Tuesday","3":"Wednesday","4":"Thursday","5":"Friday","6":"Saturday"}; 
                return week[time.getDay()+""];
            })(),
            /*
            "e+": (()=>{
                const week = {"0":"Sun","1":"Mon","2":"Tue","3":"Wed","4":"Thu","5":"Fri","6":"Sat"}; 
                return week[this.getDay()+""];
            })(),
            */
            "x1": (()=>{
                const week = {"0":"周日","1":"周一","2":"周二","3":"周三","4":"周四","5":"周五","6":"周六"}; 
                return week[time.getDay()+""];
            })(),
            "x2": (()=>{
                const hour = ["凌晨","早上","下午","晚上"];
                const h=time.getHours();
                if(h==12) return "中午";
               var s= (h/6).toString()
                return hour[parseInt(s)];
            })(),
        }
        for(var k in o) {
            if(new RegExp("("+k+")", "g").test(fmt)) {
                const len = RegExp.$1.length;
                fmt = fmt.replace(RegExp.$1, len==1?o[k]:("00"+o[k]).substr(-len));
            }
        }
        return fmt;
    }

}
